export const MAX_TITLE_ROW_COUNT = 3;
